import React, { memo, useMemo } from 'react';

import { useTheme } from "@mui/styles";
import makeStyles from '@mui/styles/makeStyles';
import { InterestedByFront } from '../interested_by_front/interested_by_front';

import { styles } from './interested_by_back_styles';
import { useCardVariant } from '../../../../hooks/profile_card_hooks/use_card_variant';
import { getColorsFromCardVariant } from '../../../../../utils/styles/styles_utils';

const useStyles = makeStyles(styles);

const InterestedByBackComponent = (props) => {
    const [variant] = useCardVariant();
    const classes = useStyles({ variant });
    const theme = useTheme();
    const overrideColor = useMemo(() => getColorsFromCardVariant(theme, variant).backgroundColor, [theme, variant]);

    return (
        <InterestedByFront
            classes={{
                container: classes.container,
                typography: classes.typography
            }}
            overrideColor={overrideColor}
            dismissButton
            {...props}
        />
    );
};

export const InterestedByBack = memo(InterestedByBackComponent);
